module.exports = __webpack_public_path__ + "img/experience-one.228da091.png";